var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconServ08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000005975142661498850600000016501525463600535992_);fill:url(#SVGID_00000075140550656311372750000016155502733657081782_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000103949490009406371890000006494919226478657683_);fill:url(#SVGID_00000001627450478045959920000007611635637737405315_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000168823801335292511800000005882166153102393238_);fill:url(#SVGID_00000083079630206752806500000014058318148959233462_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000183944910022680171680000008277172621081382289_);fill:url(#SVGID_00000119084329085107643930000000042823847647378570_);}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000080901655756124263680000014112849552892263615_);fill:url(#SVGID_00000097474913966522017340000017973198654625568933_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000056418098814499688610000016132947914061470124_);fill:url(#SVGID_00000080902709056805253900000002882052280660645296_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000091697373815501901270000018108242758086641044_);fill:url(#SVGID_00000034047519375326783680000004808375275330545804_);}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000048495913633988942390000011204424394618073498_);fill:url(#SVGID_00000021836819249461373470000012068511056516217788_);}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000152957461572379525660000006436032346639405748_);fill:url(#SVGID_00000051372155527139927210000000729318720148555954_);}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000109749354668176750680000004287447084546698131_);fill:url(#SVGID_00000028317345130983668560000000955975617331093951_);}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000078733352120863338490000008158743426873549463_);fill:url(#SVGID_00000122714001986691522070000009644644492291824265_);}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000043434609243810914760000008062531497412575880_);fill:url(#SVGID_00000047052539325042382900000002286955606684978355_);}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000122710410604730858670000001985076266598524801_);fill:url(#SVGID_00000179648550785813592130000016529497241319296677_);}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000133528349557868092960000010515928287905004965_);fill:url(#SVGID_00000160165959919130870070000010189523470697085601_);}\n\t\n\t\t.st14{clip-path:url(#SVGID_00000160876732685534641530000009704669487189669804_);fill:url(#SVGID_00000139989974404025076010000000821961875790417816_);}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000061437877759333638560000015929424916459387810_);fill:url(#SVGID_00000173150778880980976390000010868736917307396741_);}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000129907592415971468470000016839897020891272326_);fill:url(#SVGID_00000004535640903763692100000011114400402161002642_);}\n\t\n\t\t.st17{clip-path:url(#SVGID_00000030445315711329871000000013257839177015413938_);fill:url(#SVGID_00000091735484943634588210000006518060950911478940_);}\n\t\n\t\t.st18{clip-path:url(#SVGID_00000058568976174230076940000006754064909584472708_);fill:url(#SVGID_00000177469478462595120430000008216019656330379419_);}\n\t\n\t\t.st19{clip-path:url(#SVGID_00000095324015861899004960000006218610954008454297_);fill:url(#SVGID_00000133513517451492897330000016054045125522359947_);}\n\t\n\t\t.st20{clip-path:url(#SVGID_00000117653924644879493240000012131636944020511886_);fill:url(#SVGID_00000182491772074272419490000011686914019555485068_);}\n\t\n\t\t.st21{clip-path:url(#SVGID_00000041261530781973064890000005051528378436018360_);fill:url(#SVGID_00000036930996720565769600000009330096323536457628_);}\n\t\n\t\t.st22{clip-path:url(#SVGID_00000052078601168170952180000001606421070239838861_);fill:url(#SVGID_00000093137802863193669790000003472217615038041987_);}\n\t\n\t\t.st23{clip-path:url(#SVGID_00000028321463047858919050000003173550952099765376_);fill:url(#SVGID_00000026869109301595567010000000034646815242669991_);}\n\t\n\t\t.st24{clip-path:url(#SVGID_00000075885086099878707320000010256998307626550718_);fill:url(#SVGID_00000124121322051092987720000002998531452082657722_);}\n\t\n\t\t.st25{clip-path:url(#SVGID_00000159439621720067648850000006692789064577373111_);fill:url(#SVGID_00000041289756787333526160000003501255717006124167_);}\n\t\n\t\t.st26{clip-path:url(#SVGID_00000013888418995774585490000014338496373790703527_);fill:url(#SVGID_00000181767778569607928090000008655218190780747709_);}\n\t\n\t\t.st27{clip-path:url(#SVGID_00000030446044604974855990000013956407354842770578_);fill:url(#SVGID_00000152961682731210425000000015555563246264309692_);}\n\t\n\t\t.st28{clip-path:url(#SVGID_00000093865164401700473330000000136092707721524625_);fill:url(#SVGID_00000151503086891741027660000003587841185329114268_);}\n\t\n\t\t.st29{clip-path:url(#SVGID_00000111887744279774919790000011531615886791103125_);fill:url(#SVGID_00000057832697888710177150000012492901288412890773_);}\n\t\n\t\t.st30{clip-path:url(#SVGID_00000167355813778214464950000008477341326499796633_);fill:url(#SVGID_00000164486790912841871690000008642933236395849094_);}\n\t\n\t\t.st31{clip-path:url(#SVGID_00000160871612942549562000000017600708322973493925_);fill:url(#SVGID_00000155106249534198829350000009311669914491581073_);}\n\t\n\t\t.st32{clip-path:url(#SVGID_00000098904399111343556870000005112552972861717906_);fill:url(#SVGID_00000015332526309736403310000017077609018992823689_);}\n\t\n\t\t.st33{clip-path:url(#SVGID_00000103245813818722886060000003787255767369313161_);fill:url(#SVGID_00000041287128395754376420000014205168096951131542_);}\n\t\n\t\t.st34{clip-path:url(#SVGID_00000069364360486021430970000014409952358538744759_);fill:url(#SVGID_00000018936716831407820740000008951191991241724061_);}\n\t\n\t\t.st35{clip-path:url(#SVGID_00000111896754906551388870000003001043812067695023_);fill:url(#SVGID_00000054966041060734680630000017707785759390311303_);}\n\t\n\t\t.st36{clip-path:url(#SVGID_00000020392631419226089690000011310512172145095818_);fill:url(#SVGID_00000160191039649311881960000014874027598074002874_);}\n\t\n\t\t.st37{clip-path:url(#SVGID_00000063627808651843604140000002940505939152182167_);fill:url(#SVGID_00000008861269650833093870000008532344615375571605_);}\n\t\n\t\t.st38{clip-path:url(#SVGID_00000070825579723945356450000018166895843227124868_);fill:url(#SVGID_00000154396167378693311550000018380671369243367071_);}\n\t\n\t\t.st39{clip-path:url(#SVGID_00000109710842911596496080000016101829943730552207_);fill:url(#SVGID_00000051347420577378300320000010742363227854911360_);}\n\t\n\t\t.st40{clip-path:url(#SVGID_00000034811977541685464280000016764597354643252405_);fill:url(#SVGID_00000047037399837716031330000016020974241676832176_);}\n\t\n\t\t.st41{clip-path:url(#SVGID_00000052090758493327078930000007427414960041763737_);fill:url(#SVGID_00000118398725408236769760000012617859720682872460_);}\n\t\n\t\t.st42{clip-path:url(#SVGID_00000057862897396718990700000010351822647631004333_);fill:url(#SVGID_00000152242193959266962130000003424681646564841906_);}\n\t\n\t\t.st43{clip-path:url(#SVGID_00000107557728029339033220000012010727493567572125_);fill:url(#SVGID_00000093151530290791362990000014194390347118000022_);}\n\t\n\t\t.st44{clip-path:url(#SVGID_00000013168394756771313490000012899881466612628893_);fill:url(#SVGID_00000116231688255743617150000006790767788605679016_);}\n\t\n\t\t.st45{clip-path:url(#SVGID_00000019680678248974817990000006113431660338138296_);fill:url(#SVGID_00000090257817390682158420000009701501639877504152_);}\n\t\n\t\t.st46{clip-path:url(#SVGID_00000115507492589592271370000010411365721362408881_);fill:url(#SVGID_00000179615771626507742710000007780970751259262856_);}\n\t\n\t\t.st47{clip-path:url(#SVGID_00000160869128690406195240000007657062757004682124_);fill:url(#SVGID_00000113318560950579405690000017047784693215844999_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000081642973987783906210000010304497731507265422_",
    d: "M32.4,7.8l0.4,0.5c0.4,0.5,1,0.8,1.6,0.8 c0.6,0,1.3-0.2,1.8-0.6l0.1-0.1l1.6,1.9l-0.1,0.1c-1,0.9-1.1,2.4-0.3,3.4c0.9,1,2.4,1.1,3.4,0.3l0.1-0.1l1.3,1.6h-19L32.4,7.8z  M32,6.5l-10.5,9h-1.7c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h22v0.6c0,1.3,1.1,2.4,2.4,2.4h0.2v2.4h-0.2 c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4h0.2v2.4h-0.2c-1.3,0-2.4,1.1-2.4,2.4v1.4h-4.2c-0.3,0-0.6,0.3-0.6,0.6 c0,0.3,0.3,0.6,0.6,0.6h4.8c0.3,0,0.6-0.3,0.6-0.6v-2c0-0.7,0.5-1.2,1.2-1.2H45c0.3,0,0.6-0.3,0.6-0.6v-3.7 c0-0.3-0.3-0.6-0.6-0.6h-0.8c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2H45c0.3,0,0.6-0.3,0.6-0.6v-3.7c0-0.3-0.3-0.6-0.6-0.6 h-0.8c-0.7,0-1.2-0.5-1.2-1.2v-0.2l0.9-0.8c0.2-0.2,0.3-0.6,0.1-0.8l-2.4-2.8c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.3,0-0.4,0.1 l-0.6,0.5c-0.5,0.4-1.3,0.4-1.7-0.1c-0.2-0.2-0.3-0.6-0.3-0.9c0-0.3,0.2-0.6,0.4-0.8l0.6-0.5c0.3-0.2,0.3-0.6,0.1-0.9l-2.4-2.8 c-0.2-0.3-0.6-0.3-0.9-0.1l-0.6,0.5c-0.2,0.2-0.6,0.3-0.9,0.3c-0.3,0-0.6-0.2-0.8-0.4l-0.8-0.9c-0.1-0.1-0.3-0.2-0.4-0.2 c0,0,0,0,0,0C32.3,6.3,32.1,6.4,32,6.5"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151542632517919655110000000760021219258500269_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.3643,
    y1: 44.2331,
    x2: 32.3643,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081642973987783906210000010304497731507265422_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000151542632517919655110000000760021219258500269_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179647435149281564730000018107383019379652030_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081642973987783906210000010304497731507265422_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104674992283615409940000005624373986163897473_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.3643,
    y1: 44.2331,
    x2: 32.3643,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 6.3,
    style: {
      clipPath: "url(#SVGID_00000179647435149281564730000018107383019379652030_)",
      fill: "url(#SVGID_00000104674992283615409940000005624373986163897473_)"
    },
    width: 26.4,
    height: 28.1
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020393866165662040340000012550761116740611738_",
    d: "M7.6,34.5h19l-9,7.7l-0.4-0.5c-0.4-0.5-1-0.8-1.6-0.8 c-0.6-0.1-1.3,0.2-1.8,0.6l-0.1,0.1l-1.6-1.9l0.1-0.1c0.5-0.4,0.8-1,0.8-1.6c0-0.6-0.2-1.3-0.6-1.8c-0.4-0.5-1-0.8-1.6-0.8 c-0.6,0-1.3,0.2-1.8,0.6L9,36.1L7.6,34.5z M7.6,15.5c-0.3,0-0.6,0.3-0.6,0.6v2c0,0.7-0.5,1.2-1.2,1.2H5c-0.3,0-0.6,0.3-0.6,0.6 v3.7c0,0.3,0.3,0.6,0.6,0.6h0.8c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2H5c-0.3,0-0.6,0.3-0.6,0.6v3.7 c0,0.3,0.3,0.6,0.6,0.6h0.8C6.5,31.5,7,32,7,32.7V33l-0.9,0.7c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2,0,0.3,0.1,0.5l2.4,2.8 c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3,0,0.4-0.1l0.6-0.5c0.2-0.2,0.6-0.3,0.9-0.3c0.3,0,0.6,0.2,0.8,0.4c0.4,0.5,0.4,1.3-0.1,1.7 l-0.6,0.5c-0.3,0.2-0.3,0.6-0.1,0.9l2.4,2.8c0.2,0.3,0.6,0.3,0.9,0.1l0.6-0.5c0.2-0.2,0.6-0.3,0.9-0.3c0.3,0,0.6,0.2,0.8,0.4 l0.8,0.9c0.1,0.1,0.3,0.2,0.5,0.2c0.1,0,0.3,0,0.4-0.1l10.5-9c0,0,0,0,0,0h3.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-24 v-0.6c0-1.3-1.1-2.4-2.4-2.4H5.6v-2.4h0.2c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4H5.6v-2.4h0.2c1.3,0,2.4-1.1,2.4-2.4v-1.4 h7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6H7.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013910263931664960760000004842328960703896450_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.6169,
    y1: 44.2331,
    x2: 18.6169,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020393866165662040340000012550761116740611738_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000013910263931664960760000004842328960703896450_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137821082048026806660000007920595184839991698_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020393866165662040340000012550761116740611738_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145766620338238890390000010751503481112145323_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.6169,
    y1: 44.2331,
    x2: 18.6169,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4.4,
    y: 15.5,
    style: {
      clipPath: "url(#SVGID_00000137821082048026806660000007920595184839991698_)",
      fill: "url(#SVGID_00000145766620338238890390000010751503481112145323_)"
    },
    width: 28.4,
    height: 28.1
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000077313039336099715850000015381633634591684509_",
    d: "M21.5,18.4c-0.3,0-0.6,0.3-0.6,0.6 c0,0.3,0.3,0.6,0.6,0.6h16.8v10.8H11.8V19.6h5c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-5.6c-0.3,0-0.6,0.3-0.6,0.6v12 c0,0.3,0.3,0.6,0.6,0.6h27.6c0.3,0,0.6-0.3,0.6-0.6V19c0-0.3-0.3-0.6-0.6-0.6H21.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155106780805646878950000017817670369461379480_",
    gradientUnits: "userSpaceOnUse",
    x1: 25,
    y1: 44.2331,
    x2: 25,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077313039336099715850000015381633634591684509_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000155106780805646878950000017817670369461379480_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163768284694472533780000009316245821444989106_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077313039336099715850000015381633634591684509_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034075590102774976150000012045182379802461858_",
    gradientUnits: "userSpaceOnUse",
    x1: 25,
    y1: 44.2331,
    x2: 25,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 18.4,
    style: {
      clipPath: "url(#SVGID_00000163768284694472533780000009316245821444989106_)",
      fill: "url(#SVGID_00000034075590102774976150000012045182379802461858_)"
    },
    width: 28.9,
    height: 13.3
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000167359441568656255910000016535740301695023030_",
    d: "M13.6,22.3c-0.2,0-0.3,0.2-0.3,0.5 c0,0.3,0.1,0.5,0.3,0.5h1.2v4.6c0,0.2,0.3,0.3,0.5,0.3c0.3,0,0.5-0.1,0.5-0.3v-4.6H17c0.2,0,0.3-0.2,0.3-0.5 c0-0.2-0.1-0.5-0.3-0.5H13.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165914529743284944740000004850734917791284122_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.3299,
    y1: 44.2331,
    x2: 15.3299,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167359441568656255910000016535740301695023030_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000165914529743284944740000004850734917791284122_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054238521793943952860000009509016978898786988_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167359441568656255910000016535740301695023030_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181071020807704902470000013116664198086448263_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.3299,
    y1: 44.2331,
    x2: 15.3299,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.3,
    y: 22.3,
    style: {
      clipPath: "url(#SVGID_00000054238521793943952860000009509016978898786988_)",
      fill: "url(#SVGID_00000181071020807704902470000013116664198086448263_)"
    },
    width: 4,
    height: 5.8
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000101092715258749846210000014721936133604388758_",
    d: "M17.9,22.7v5.2c0,0.2,0.3,0.3,0.5,0.3 c0.3,0,0.5-0.1,0.5-0.3v-5.2c0-0.2-0.3-0.3-0.5-0.3C18.2,22.3,17.9,22.4,17.9,22.7"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123412378765650700350000017751716604594955948_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.4208,
    y1: 44.2331,
    x2: 18.4208,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101092715258749846210000014721936133604388758_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000123412378765650700350000017751716604594955948_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006699271341289830110000006346971194802673285_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101092715258749846210000014721936133604388758_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016050879072560547380000017484563065366294183_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.4207,
    y1: 44.2331,
    x2: 18.4207,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.9,
    y: 22.3,
    style: {
      clipPath: "url(#SVGID_00000006699271341289830110000006346971194802673285_)",
      fill: "url(#SVGID_00000016050879072560547380000017484563065366294183_)"
    },
    width: 1,
    height: 5.8
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000140698112599322882050000008984013662807601598_",
    d: "M19.8,24.2v2.2c0,1.3,0.8,1.8,1.8,1.8 c1.1,0,1.9-0.6,1.9-1.6c0-0.4-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.1-0.5,0.3c0,0.3-0.1,0.9-0.8,0.9c-0.5,0-0.9-0.3-0.9-0.9v-2.2 c0-0.6,0.3-0.9,0.8-0.9c0.8,0,0.8,0.5,0.8,0.8c0,0.2,0.2,0.3,0.5,0.3c0.3,0,0.5-0.1,0.5-0.5c0-0.9-0.8-1.5-1.9-1.5 C20.7,22.3,19.8,22.8,19.8,24.2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152265756147748551060000009642841807775867832_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.7031,
    y1: 44.2331,
    x2: 21.7031,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140698112599322882050000008984013662807601598_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000152265756147748551060000009642841807775867832_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078030950606449115000000015189001039718042288_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140698112599322882050000008984013662807601598_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098940029346079141110000010976543892521345683_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.7031,
    y1: 44.2331,
    x2: 21.7031,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.8,
    y: 22.3,
    style: {
      clipPath: "url(#SVGID_00000078030950606449115000000015189001039718042288_)",
      fill: "url(#SVGID_00000098940029346079141110000010976543892521345683_)"
    },
    width: 3.7,
    height: 5.9
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000083781862744511876280000011348982452928155829_",
    d: "M27,22.5l-1.7,2.3v-2.2c0-0.2-0.3-0.3-0.5-0.3 c-0.3,0-0.5,0.1-0.5,0.3v5.2c0,0.2,0.3,0.3,0.5,0.3c0.3,0,0.5-0.1,0.5-0.3v-1.6l0.4-0.5l1.5,2.3c0.1,0.1,0.2,0.2,0.4,0.2 c0.3,0,0.6-0.3,0.6-0.5c0-0.1,0-0.1-0.1-0.2l-1.7-2.6l1.4-1.8c0.1-0.1,0.1-0.1,0.1-0.2c0-0.3-0.3-0.5-0.6-0.5 C27.2,22.3,27.1,22.4,27,22.5"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021837387936164331860000008274460687576085421_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.238,
    y1: 44.2331,
    x2: 26.238,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083781862744511876280000011348982452928155829_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000021837387936164331860000008274460687576085421_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060737121476885911130000001831709723778237843_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083781862744511876280000011348982452928155829_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008129919898910748940000010312458379644338838_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.238,
    y1: 44.2331,
    x2: 26.238,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 24.3,
    y: 22.3,
    style: {
      clipPath: "url(#SVGID_00000060737121476885911130000001831709723778237843_)",
      fill: "url(#SVGID_00000008129919898910748940000010312458379644338838_)"
    },
    width: 3.9,
    height: 5.9
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000022526166372141857590000016089527967373047185_",
    d: "M29.1,22.3c-0.2,0-0.5,0.1-0.5,0.3v5.2 c0,0.2,0.2,0.3,0.5,0.3h2.8c0.2,0,0.3-0.2,0.3-0.4c0-0.2-0.1-0.5-0.3-0.5h-2.3v-1.6h1.2c0.2,0,0.3-0.2,0.3-0.4 c0-0.2-0.1-0.4-0.3-0.4h-1.2v-1.6h2.3c0.2,0,0.3-0.2,0.3-0.5c0-0.2-0.1-0.4-0.3-0.4H29.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103265377398921185670000011417242652705204865_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.4668,
    y1: 44.2331,
    x2: 30.4668,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022526166372141857590000016089527967373047185_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000103265377398921185670000011417242652705204865_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165195081974431545260000004382931299297807015_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022526166372141857590000016089527967373047185_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125599943627941832380000001820696807027847335_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.4668,
    y1: 44.2331,
    x2: 30.4668,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28.7,
    y: 22.3,
    style: {
      clipPath: "url(#SVGID_00000165195081974431545260000004382931299297807015_)",
      fill: "url(#SVGID_00000125599943627941832380000001820696807027847335_)"
    },
    width: 3.6,
    height: 5.8
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000057114452036731147900000008076652873307010739_",
    d: "M32.8,22.3c-0.2,0-0.3,0.2-0.3,0.5 c0,0.3,0.1,0.5,0.3,0.5H34v4.6c0,0.2,0.3,0.3,0.5,0.3c0.3,0,0.5-0.1,0.5-0.3v-4.6h1.2c0.2,0,0.3-0.2,0.3-0.5 c0-0.2-0.1-0.5-0.3-0.5H32.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111887128561218844550000009702789072436499106_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.5041,
    y1: 44.2331,
    x2: 34.5041,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057114452036731147900000008076652873307010739_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000111887128561218844550000009702789072436499106_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031170436153877408860000000529022205273356440_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057114452036731147900000008076652873307010739_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031168240075059086270000005872492612415663543_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.5041,
    y1: 44.2331,
    x2: 34.5041,
    y2: 7.2115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 22.3,
    style: {
      clipPath: "url(#SVGID_00000031170436153877408860000000529022205273356440_)",
      fill: "url(#SVGID_00000031168240075059086270000005872492612415663543_)"
    },
    width: 4,
    height: 5.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServ08);
export default __webpack_public_path__ + "static/media/IconServ-08.b2bbc95eea0d74f53deb6550cf3127bf.svg";
export { ForwardRef as ReactComponent };